import { lazy } from 'react';
/** Открывает форму подписки клиента */
export const ClientSubscriptionFormPageAsync = lazy(() => import('./ClientSubscriptionForm/ClientSubscriptionFormPage'));